import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from '@patternfly/react-styles/css/components/Menu/menu.mjs';
import { css } from '@patternfly/react-styles';
export const MenuSearch = forwardRef((props, ref) => (_jsx("div", Object.assign({}, props, { className: css(styles.menuSearch, props.className), ref: ref }))));
MenuSearch.displayName = 'MenuSearch';
//# sourceMappingURL=MenuSearch.js.map